import { Store, createStore, applyMiddleware } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { Persistor } from 'redux-persist/es/types';
import createSagaMiddleware from 'redux-saga';
// `react-router-redux` is deprecated, so we use `connected-react-router`.
// This provides a Redux middleware which connects to our `react-router` instance.
import { routerMiddleware } from 'connected-react-router';
// We'll be using Redux Devtools. We can use the `composeWithDevTools()`
// directive so we can pass our middleware along with it
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
// If you use react-router, don't forget to pass in your history type.
import { History } from 'history';

// Import the state interface and our combined reducers/sagas.
import { ApplicationState, createRootReducer, rootSaga } from './store';

const logger = createLogger({
  diff: true,
  collapsed: true,
});

// 永続化の設定
const persistConfig = {
  // Storageに保存されるキー名を指定する
  key: 'admin',
  // 保存先としてlocalStorageがここで設定される
  storage,
  // Stateは`admin`をStorageに保存する
  whitelist: ['admin'],
};

export default function configureStore(
  history: History,
): [Store<ApplicationState>, Persistor] {
  // create the composing function for our middlewares
  const composeEnhancers = composeWithDevTools({});
  // create the redux-saga middleware
  const sagaMiddleware = createSagaMiddleware();

  const rootReducer = createRootReducer(history);
  // 永続化設定されたReducerとして定義
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  // We'll create our store with the combined reducers/sagas, and the initial Redux state that
  // we'll be passing from our entry point.
  const store = createStore(
    persistedReducer,
    composeEnhancers(
      applyMiddleware(routerMiddleware(history), logger, sagaMiddleware),
    ),
  );

  // Don't forget to run the root saga, and return the store object.
  sagaMiddleware.run(rootSaga);
  return [store, persistStore(store)];
}
